<div class="container">
  <q9-toolbar>
    <div q9-left-content>
      <q9ma-space-navigation></q9ma-space-navigation>
    </div>

    <div q9-right-content>
      <ng-container *ngIf="isFree() || (isMsSpace() && !hasSubscription())">
        <span
          [matTooltip]="'BILLING.NEED_PERMISSIONS_UPGRADE' | translate"
          [matTooltipDisabled]="isSpaceAdmin()"
          [matTooltipPosition]="'below'">
          <q9-primary-button
            class="upgrade-btn"
            (click)="openPricingCalculator()"
            [disabled]="!isSpaceAdmin()">
            {{ 'GENERAL.UPGRADE' | translate }}
          </q9-primary-button>
        </span>
      </ng-container>

      <q9-primary-button
        *ngIf="canInviteUsers()"
        [matTooltip]="'TEAMS.INVITE_BTN' | translate"
        [matTooltipPosition]="'below'"
        (click)="openInviteUser()">
        {{ 'GENERAL.INVITE' | translate | titlecase }}
      </q9-primary-button>

      <span
        [matTooltip]="
          (!hasDecisionEngineLicense()
            ? 'DECISION_ENGINE.LICENSE_REQUIRED'
            : !elementsGPTEnabledInSpace()
              ? 'DECISION_ENGINE.ELEMENTS_GPT_DISABLED'
              : !isEditor()
                ? 'DECISION_ENGINE.EDITOR_REQUIRED'
                : 'DECISION_ENGINE.ICON_TOOLTIP'
          ) | translate
        "
        matTooltipPosition="below">
        <q9-icon-button
          class="decision-engine-entry-btn"
          icon="ai_agents"
          iconColor="primary"
          [disabled]="!hasDecisionEngineLicense() || !elementsGPTEnabledInSpace() || !isEditor()"
          (click)="navigateToDecisionEngine()"></q9-icon-button>
      </span>

      <q9-theme-switcher></q9-theme-switcher>
      <ng-container *ngTemplateOutlet="settings"></ng-container>
      <q9-reports (reportAction)="onChange($event)"></q9-reports>
      <q9-notifications></q9-notifications>
      <q9-trainings></q9-trainings>

      <q9-profile-menu>
        <button mat-menu-item (click)="navigateTo('profile')">
          {{ 'HEADER.PROFILE' | translate }}
        </button>
        <button mat-menu-item (click)="openSysAdminApp()" *ngIf="isSysAdmin()">
          {{ 'HEADER.SYSADMIN_APP' | translate }}
        </button>
      </q9-profile-menu>
    </div>
  </q9-toolbar>

  <q9-navigation-sidebar>
    <q9-navigation-link
      *ngFor="let module of availableModules()"
      (click)="navigateTo(module.path)"
      [icon]="module.icon"
      [ref]="module.path"
      [relatedRoutes]="module?.relatedRoutes">
      {{ module.title | translate }}
    </q9-navigation-link>

    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </q9-navigation-sidebar>
</div>

<ng-template #settings>
  <q9-icon-button
    icon="settings"
    [matTooltip]="'HEADER.SETTINGS' | translate"
    [matTooltipPosition]="'below'"
    [matMenuTriggerFor]="menu"></q9-icon-button>

  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      *ngIf="hasSubscription()"
      (click)="openBillingPortal()"
      [disabled]="!isSpaceAdmin()"
      [matTooltip]="'BILLING.NEED_PERMISSIONS_MANAGE' | translate"
      [matTooltipDisabled]="isSpaceAdmin()">
      {{ 'BILLING.MANAGE_SUBSCRIPTION' | translate }}
    </button>

    <button mat-menu-item *ngIf="hasSubscription() || isFree()" (click)="openUsageSettings()">
      {{ 'BILLING.CREDIT_USAGE_HISTORY' | translate }}
    </button>

    <button mat-menu-item (click)="openSpaceManagementApp()">
      {{ 'HEADER.SPACE_MANAGEMENT' | translate }}
    </button>

    <button *ngIf="hasAccessToEnterprise()" mat-menu-item (click)="openCorporateManagementApp()">
      {{ 'HEADER.GLOBAL_MANAGEMENT' | translate }}
    </button>
  </mat-menu>
</ng-template>
